var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EventEmitter } from '@angular/core';
import { CustomerService } from '@modules/Customer/services/CustomerService';
import { ProductService } from '@modules/Product/services/ProductService';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ExcepionHandlingService } from '@core/services/ExceptionHandlingService';
var ProductsListComponent = /** @class */ (function () {
    function ProductsListComponent(customerService, productService, modalService, exception) {
        this.customerService = customerService;
        this.productService = productService;
        this.modalService = modalService;
        this.exception = exception;
        this.update = new EventEmitter();
    }
    ProductsListComponent.prototype.isAttached = function (id) {
        return this.productService.isAttached(id, this.customer);
    };
    ProductsListComponent.prototype.confirmModel = function (content) {
        this.modalReference = this.modalService.open(content, { centered: true });
    };
    ProductsListComponent.prototype.addRemoveProduct = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var method, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        method = this.isAttached(id) ? 'removeProduct' : 'addProduct';
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        this.loading = true;
                        return [4 /*yield*/, this.customerService[method](this.customer, id)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        this.error = this.exception.errorDisplay(error_1);
                        return [3 /*break*/, 5];
                    case 4:
                        this.loading = false;
                        if (this.error === undefined) {
                            if (this.isAttached(id)) {
                                this.customer.products.splice(this.customer.products.findIndex(function (item) { return item.id === id; }), 1);
                            }
                            else {
                                this.customer.products.push({ id: id, name: '' });
                            }
                        }
                        return [7 /*endfinally*/];
                    case 5:
                        this.modalReference.close();
                        return [2 /*return*/];
                }
            });
        });
    };
    ProductsListComponent.prototype.isActionShown = function (action) {
        return this.actions.indexOf(action) >= 0;
    };
    return ProductsListComponent;
}());
export { ProductsListComponent };
